import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { classnames } from '@@client/lib/classes';
var columnStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "3549171850",
    children: ["@media(min-width:768px){.jsx-3549171850:first-child{padding-right:13px;}}", "@media(min-width:768px){.jsx-3549171850:last-child{padding-left:13px;}}"]
  }),
  className: "jsx-3549171850"
};
export var Main = function Main(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-2462906563" + " " + (classnames('content-area', 'page-padding-tb', 'pad-left-gutter', 'pad-right-gutter', columnStyle.className) || ""),
      children: children
    }), columnStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2462906563",
      children: [".content-area.jsx-2462906563{-webkit-box-flex:1;-ms-flex-positive:1;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;}"]
    })]
  });
};
export var Sidebar = function Sidebar(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-767512945" + " " + (classnames('sidebar', className, 'page-padding-tb', 'pad-left-gutter', 'pad-right-gutter', columnStyle.className) || ""),
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-767512945" + " " + 'inner',
        children: children
      })
    }), columnStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "767512945",
      children: [".sidebar.jsx-767512945{background:#E7E7EC;}", ".sidebar.jsx-767512945:last-child{-webkit-box-ordinal-group:0;-ms-flex-order:-1;-webkit-order:-1;-ms-flex-order:-1;order:-1;}", "@media(min-width:768px){.sidebar.jsx-767512945:last-child{-webkit-box-ordinal-group:unset;-ms-flex-order:unset;-webkit-order:unset;-ms-flex-order:unset;order:unset;}}", "@media(min-width:768px){.inner.jsx-767512945{width:270px;}}", "@media(min-width:992px){.inner.jsx-767512945{width:290px;}}"]
    })]
  });
};
export var SubLayoutGraySidebar = function SubLayoutGraySidebar(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-718078175" + " " + 'container',
      children: children
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "718078175",
      children: [".container.jsx-718078175{display:grid;}", "@media(min-width:768px){.container.jsx-718078175{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}}"]
    })]
  });
};